import * as yup from 'yup';
import { areDatesOnTheSameDay, checkDateLowerTimeInterval, checkDateUpperTimeInterval } from 'utils/date';

export const characterizationFormSchema = (
  pt: any,
  closureDate: Date | null,
  twoMonthAfterClosureDate: Date | null,
): yup.AnyObjectSchema =>
  yup.object().shape({
    weight: yup
      .number()
      .transform(value => (isNaN(value) ? undefined : value))
      .required(pt('validation.weight.required'))
      .typeError(pt('validation.weight.invalid'))
      .moreThan(0, pt('validation.weight.invalid')),
    samplingDate: yup
      .date()
      .typeError(pt('validation.samplingDate.invalid'))
      .nullable()
      .required(pt('validation.samplingDate.required'))
      .test('previousThanToday', pt('validation.samplingDate.previousThanToday'), (value, _) => {
        const today = new Date();
        return checkDateUpperTimeInterval(value, today);
      })
      .test('alreadyClosedMonth', pt('validation.samplingDate.alreadyClosedMonth'), (value, _) =>
        checkDateLowerTimeInterval(value, closureDate),
      )
      .test('datePreviousThanClosure', pt('validation.samplingDate.previousThanClosure'), (value, _) =>
        checkDateUpperTimeInterval(value, twoMonthAfterClosureDate),
      ),
    analyseDate: yup.lazy(value => {
      if (value === '' || null === value) {
        return yup.string().nullable();
      }
      return yup
        .date()
        .typeError(pt('validation.analyseDate.invalid'))
        .nullable()
        .test('previousThanToday', pt('validation.analyseDate.previousThanToday'), (value, _) => {
          const today = new Date();
          return checkDateUpperTimeInterval(value, today);
        })
        .test('analyseDateValidation', pt('validation.analyseDate.laterThanSampling'), (value, context) => {
          const samplingDate = context.parent.samplingDate;
          return !value || '' === samplingDate || samplingDate <= value || areDatesOnTheSameDay(value, samplingDate);
        });
    }),
    client: yup.string().required(pt('validation.requiredClient')),
    stream: yup.string().required(pt('validation.requiredStream')),
  });
